<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />

          <div class="d-flex flex-between my-3">
            <h4 class="text-uppercase mb-0">data rawat jalan</h4>
            <div class="d-flex" v-if="status != 'DIBATALKAN'">
              <router-link
                :to="
                  `/ralan/form/edit/${$route.params.id}?fromTab=${tabActive}`
                "
                class="btn btn-with-icon-left btn-primary text-uppercase mr-2"
              >
                <i class="material-symbols-outlined">create</i>
                Ubah Data
              </router-link>
              <router-link
                :to="
                  `/ralan/cetak-kartu/${$route.params.id}?fromTab=${tabActive}`
                "
                class="btn btn-with-icon-left btn-success text-uppercase mr-2"
              >
                <i class="material-symbols-outlined">print</i>
                Cetak Kartu Rawat Jalan
              </router-link>
              <router-link
                :to="`/ranap/form/${id_ralan}/0?fromTab=${tabActive}`"
                class="btn btn-with-icon-left btn-secondary text-uppercase"
              >
                <i class="material-symbols-outlined">add</i>
                Daftarkan Rawat Inap
              </router-link>
            </div>
          </div>
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>

          <div v-if="status != 'DIBATALKAN'">
            <div class="card mb-4 p-3">
              <h5 class="mb-3 no-print">Buat Surat</h5>
              <div class="row no-print">
                <div class="col-md-12 d-flex flex-between">
                  <router-link
                    :to="`/document/${slug}/surat-ket-sakit`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-primary
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Ket. Sakit
                  </router-link>
                  <router-link
                    :to="`/document/${slug}/surat-ket-medis`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-secondary
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Ket. Medis
                  </router-link>
                  <router-link
                    :to="`/document/${slug}/surat-kontrol`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-info
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Surat Kontrol
                  </router-link>
                  <router-link
                    :to="`/document/${slug}/surat-periksa-mata`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-danger
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Periksa Mata
                  </router-link>
                  <router-link
                    :to="`/document/${slug}/surat-rujukan`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-warning
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Rujukan
                  </router-link>
                  <router-link
                    :to="`/document/${slug}/surat-rujuk-balik`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-success
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Rujuk Balik
                  </router-link>
                  <router-link
                    :to="`/document/${slug}/surat-permintaan-konsultasi`"
                    target="_blank"
                    class="
                      btn btn-with-icon-left btn-outline-secondary
                      text-uppercase
                    "
                  >
                    <i class="material-symbols-outlined">print</i>
                    Surat Konsultasi
                  </router-link>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-12">
                <b-tabs pills>
                  <b-tab
                    title="DATA PEMERIKSAAN"
                    :active="tabActive == 'pemeriksaan'"
                  >
                    <div>
                      <div class="d-flex flex-between my-3">
                        <h4 class="text-uppercase mb-0">hasil pemeriksaan</h4>
                        <router-link
                          :to="
                            `/ralan/cetak-kajian-medis/${$route.params.id}?fromTab=pemeriksaan`
                          "
                          target="_blank"
                          class="
                            btn btn-with-icon-left btn-secondary
                            text-uppercase
                          "
                        >
                          <i class="material-symbols-outlined">print</i>
                          cetak kajian medis
                        </router-link>
                      </div>
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Hasil Pemeriksaan perawat</h5>
                        <router-link
                          v-if="dataPetugasLeft || dataPetugasRight"
                          :to="
                            `/ralan/form-petugas/edit/${$route.params.id}?fromTab=pemeriksaan`
                          "
                          class="btn btn-with-icon-left btn-primary"
                        >
                          <i class="material-symbols-outlined">create</i>
                          Ubah Data
                        </router-link>
                      </div>
                      <div
                        class="row mb-4"
                        v-if="dataPetugasLeft || dataPetugasRight"
                      >
                        <div class="col-md-7 pr-1">
                          <DetailLeft :detailLeftTop="dataPetugasLeft" />
                        </div>
                        <div class="col-md-5 pl-1">
                          <DetailRight :detailRightTop="dataPetugasRight" />
                        </div>
                      </div>
                      <EmptyState v-else :data="emptyPtg" />
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Hasil Pemeriksaan Ophthalmic</h5>
                        <router-link
                          v-if="dataOphthalmic"
                          :to="
                            `/ralan/form-ophthalmic/edit/${$route.params.id}?fromTab=pemeriksaan`
                          "
                          class="btn btn-with-icon-left btn-primary"
                        >
                          <i class="material-symbols-outlined">create</i>
                          Ubah Data
                        </router-link>
                      </div>
                      <div class="row mb-4" v-if="dataOphthalmic">
                        <div class="col-md-12">
                          <DetailLeft
                            v-if="dataOphthalmic"
                            :detailLeftTop="dataOphthalmic"
                          />
                          <TabelOphthalmicDisabled
                            v-if="dataTabelOphthalmic"
                            :data="dataTabelOphthalmic"
                          />
                        </div>
                      </div>
                      <EmptyState v-else :data="emptyOph" />
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Hasil Pemeriksaan Dokter</h5>
                        <router-link
                          v-if="dataDokterLeft || dataDokterRight"
                          :to="
                            `/ralan/form-dokter/edit/${$route.params.id}?fromTab=pemeriksaan`
                          "
                          class="btn btn-with-icon-left btn-primary"
                        >
                          <i class="material-symbols-outlined">create</i>
                          Ubah Data
                        </router-link>
                      </div>
                      <div
                        class="row mb-4"
                        v-if="dataDokterLeft || dataDokterRight"
                      >
                        <div class="col-md-6">
                          <DetailRight :detailRightTop="dataDokterLeft" />
                        </div>
                        <div class="col-md-6">
                          <DetailRight :detailRightTop="dataDokterRight" />
                        </div>
                      </div>
                      <EmptyState v-else :data="emptyDok" /></div
                  ></b-tab>
                  <b-tab title="DATA TINDAKAN" :active="tabActive == 'tindakan'"
                    ><div>
                      <div class="d-flex flex-between my-3">
                        <h4 class="text-uppercase mb-0">data tindakan</h4>
                        <router-link
                          :to="
                            '/ralan/form-tindakan/' +
                              $route.params.id +
                              '?fromTab=tindakan'
                          "
                          class="
                            btn btn-with-icon-left btn-secondary
                            text-uppercase
                          "
                        >
                          <i class="material-symbols-outlined">create</i>
                          ubah data tindakan
                        </router-link>
                      </div>
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Penanganan oleh Dokter</h5>
                      </div>
                      <table class="responsive" v-if="doc.length">
                        <thead>
                          <th>KODE</th>
                          <th>NAMA PERAWATAN</th>
                          <th>KATEGORI PERAWATAN</th>
                          <th>TARIF/BIAYA</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in doc"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>{{ item.kode }}</td>
                            <td>{{ item.nama }}</td>
                            <td>{{ item.kategori }}</td>
                            <td>{{ item.formatted_biaya }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState :data="emptyTindakan" v-else />
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Penanganan oleh Petugas</h5>
                      </div>
                      <table class="responsive" v-if="nrs.length">
                        <thead>
                          <th>KODE</th>
                          <th>NAMA PERAWATAN</th>
                          <th>KATEGORI PERAWATAN</th>
                          <th>TARIF/BIAYA</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in nrs"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>{{ item.kode }}</td>
                            <td>{{ item.nama }}</td>
                            <td>{{ item.kategori }}</td>
                            <td>{{ item.formatted_biaya }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState :data="emptyTindakan" v-else />
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
                      </div>
                      <table class="responsive" v-if="both.length">
                        <thead>
                          <th>KODE</th>
                          <th>NAMA PERAWATAN</th>
                          <th>KATEGORI PERAWATAN</th>
                          <th>TARIF/BIAYA</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in both"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>{{ item.kode }}</td>
                            <td>{{ item.nama }}</td>
                            <td>{{ item.kategori }}</td>
                            <td>{{ item.formatted_biaya }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState :data="emptyTindakan" v-else />
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Pemeriksaan Lab</h5>
                      </div>
                      <table class="responsive" v-if="lab.length">
                        <thead>
                          <th>KODE</th>
                          <th>NAMA PEMERIKSAAN LAB</th>
                          <th>TARIF/BIAYA</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in lab"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>{{ item.kode }}</td>
                            <td>{{ item.nama }}</td>
                            <td>{{ item.formatted_biaya }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState :data="emptyLab" v-else /></div
                  ></b-tab>
                  <b-tab title="DATA RESEP" :active="tabActive == 'resep'"
                    ><div>
                      <div class="d-flex flex-between my-3">
                        <h4 class="text-uppercase mb-0">resep</h4>
                      </div>
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Resep Obat / Alkes</h5>
                        <div class="d-flex">
                          <router-link
                            :to="`/ralan/cetak-resep-obat/${$route.params.id}`"
                            target="_blank"
                            class="btn btn-with-icon-left btn-basic mr-2"
                            v-if="obat.length"
                          >
                            <i class="material-symbols-outlined">print</i>
                            Cetak Resep Obat
                          </router-link>
                          <router-link
                            :to="
                              '/ralan/form-obat/' +
                                $route.params.id +
                                '?fromTab=resep'
                            "
                            class="btn btn-with-icon-left btn-secondary"
                          >
                            <i class="material-symbols-outlined">create</i>
                            Ubah Resep Obat
                          </router-link>
                        </div>
                      </div>
                      <table class="responsive" v-if="obat.length">
                        <thead>
                          <th>
                            KODE / NAMA BARANG / JENIS OBAT / GOLONGAN OBAT
                          </th>
                          <!-- <th>LOKASI</th> -->
                          <th>HARGA/SATUAN</th>
                          <th>JUMLAH</th>
                          <th>EMBALASE</th>
                          <th>TUSLAH</th>
                          <th>ATURAN PAKAI</th>
                          <th>SUB TOTAL</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in obat"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>
                              {{ item.kode }} / {{ item.nama }} /
                              {{ item.jenis }} / {{ item.golongan_obat }}
                            </td>
                            <!-- <td>{{ item.lokasi }}</td> -->
                            <td>{{ item.formatted_harga }}</td>
                            <td>{{ item.jumlah }}</td>
                            <td>{{ item.formatted_embalase }}</td>
                            <td>{{ item.formatted_tuslah }}</td>
                            <td>{{ item.catatan_dokter }}</td>
                            <td>{{ item.formatted_sub_total }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState v-else :data="emptyObat" />
                      <div class="d-flex flex-between my-3">
                        <h5 class="mb-2">Resep Optik</h5>
                        <div class="d-flex">
                          <router-link
                            v-if="resepOptik || optik.length"
                            :to="`/ralan/cetak-resep-optik/${$route.params.id}`"
                            target="_blank"
                            class="btn btn-with-icon-left btn-basic mr-2"
                          >
                            <i class="material-symbols-outlined">print</i>
                            Cetak Resep Optik
                          </router-link>
                          <router-link
                            :to="
                              '/ralan/form-optik/' +
                                $route.params.id +
                                '?fromTab=resep'
                            "
                            class="btn btn-with-icon-left btn-secondary"
                          >
                            <i class="material-symbols-outlined">create</i>
                            Ubah Resep Optik
                          </router-link>
                        </div>
                      </div>
                      <table class="responsive mb-4" v-if="resepOptik">
                        <thead>
                          <th>EYE</th>
                          <th>SPH</th>
                          <th>CYL</th>
                          <th>AXIS</th>
                          <th>ADD</th>
                          <th>PD</th>
                          <th>MPD</th>
                          <th>PV</th>
                          <th>PRISMA</th>
                          <th>VISUS</th>
                          <th>KET</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>O.D.</td>
                            <td>{{ resepOptik.od_sph }}</td>
                            <td>{{ resepOptik.od_cyl }}</td>
                            <td>{{ resepOptik.od_axis }}</td>
                            <td>{{ resepOptik.od_add }}</td>
                            <td>{{ resepOptik.od_pd }}</td>
                            <td>{{ resepOptik.od_mpd }}</td>
                            <td>{{ resepOptik.od_pv }}</td>
                            <td>{{ resepOptik.od_prsm }}</td>
                            <td>{{ resepOptik.od_visus }}</td>
                            <td>{{ resepOptik.od_ket }}</td>
                          </tr>
                          <tr>
                            <td>O.S.</td>
                            <td>{{ resepOptik.os_sph }}</td>
                            <td>{{ resepOptik.os_cyl }}</td>
                            <td>{{ resepOptik.os_axis }}</td>
                            <td>{{ resepOptik.os_add }}</td>
                            <td>{{ resepOptik.os_pd }}</td>
                            <td>{{ resepOptik.os_mpd }}</td>
                            <td>{{ resepOptik.os_pv }}</td>
                            <td>{{ resepOptik.os_prsm }}</td>
                            <td>{{ resepOptik.os_visus }}</td>
                            <td>{{ resepOptik.os_ket }}</td>
                          </tr>
                          <tr>
                            <td colspan="3">Visus Kacamata Lama</td>
                            <td>{{ resepOptik.visus_km_lama }}</td>
                            <td colspan="3" class="text-right">
                              Kategori Lensa
                            </td>
                            <td colspan="4">
                              {{ resepOptik.od_kategori_lensa }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table v-if="optik.length" class="responsive">
                        <thead>
                          <th>KODE</th>
                          <th>NAMA BARANG</th>
                          <th>JENIS OPTIK</th>
                          <th>LOKASI</th>
                          <th>HARGA/PC</th>
                          <th>JUMLAH</th>
                          <th>EMBALASE</th>
                          <th>TUSLAH</th>
                          <th>SUB TOTAL</th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in optik"
                            v-bind:key="item.id + item.kode + Math.random(1024)"
                          >
                            <td>{{ item.kode }}</td>
                            <td>{{ item.nama }}</td>
                            <td>{{ item.jenis }}</td>
                            <td>{{ item.lokasi }}</td>
                            <td>{{ item.formatted_harga }}</td>
                            <td>{{ item.jumlah }}</td>
                            <td>{{ item.formatted_embalase }}</td>
                            <td>{{ item.formatted_tuslah }}</td>
                            <td>{{ item.formatted_sub_total }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <EmptyState v-else :data="emptyOptik" /></div
                  ></b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import EmptyState from "@/components/EmptyState.vue";
import TabelOphthalmicDisabled from "@/components/TabelOphthalmicDisabled.vue";
// import { HTTP } from "@/config.js";
import { data, longText, tabs } from "@/data/RalanDetail.js";
import {
  setPatientIntro,
  setPeriksaPetugas,
  setPeriksaDokter,
  setPeriksaOphthalmic,
} from "@/data/helper.js";

export default {
  name: "RalanDetail",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    DetailLeft,
    DetailRight,
    TabelOphthalmicDisabled,
    EmptyState,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        "SEDANG DIPERIKSA": "secondary",
        SELESAI: "success",
        "MENUNGGU PEMBAYARAN": "warning",
        "SELESAI DIPERIKSA": "info",
      },
      test: "hahaha",
      id_ralan: "",
      status: "",
      data: data,
      longText: longText,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      detailBottom: null,
      detailApproval: null,
      dataPetugasLeft: null,
      dataPetugasRight: null,
      dataOphthalmic: null,
      dataTabelOphthalmic: null,
      dataDokterLeft: null,
      dataDokterRight: null,
      tabs: tabs,
      emptyPtg: {
        img: "/img/nurse.svg",
        title: "Belum Ada Pemeriksaan Perawat",
        content:
          "Isi data pemeriksaan perawat dengan mengeklik tombol di bawah ini",
        size: "small",
        link:
          "/ralan/form-petugas/" +
          this.$route.params.id +
          "?fromTab=pemeriksaan",
        label: "Input Pemeriksaan Perawat",
      },
      emptyOph: {
        img: "/img/oph.svg",
        title: "Belum ada pemeriksaan ophthalmic",
        content:
          "Isi data pemeriksaan ophthalmic dengan mengeklik tombol di bawah ini",
        size: "small",
        link:
          "/ralan/form-ophthalmic/" +
          this.$route.params.id +
          "?fromTab=pemeriksaan",
        label: "Input Pemeriksaan Ophthalmic",
      },
      emptyDok: {
        img: "/img/doctor.svg",
        title: "Belum ada pemeriksaan dokter",
        content:
          "Isi data pemeriksaan dokter dengan mengeklik tombol di bawah ini",
        size: "small",
        link:
          "/ralan/form-dokter/" +
          this.$route.params.id +
          "?fromTab=pemeriksaan",
        label: "Input Pemeriksaan Dokter",
      },
      emptyTindakan: {
        img: "/img/nurse.svg",
        title: "Belum ada data tindakan",
        content: "Isi data tindakan dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyLab: {
        img: "/img/lab.svg",
        title: "Belum ada data",
        content:
          "Isi data pemeriksaan lab dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyObat: {
        img: "/img/med.svg",
        title: "Belum ada resep obat",
        content: "Input resep obat dengan mengeklik tombol Ubah Resep Obat",
        size: "small",
        link: "",
        label: "",
      },
      emptyOptik: {
        img: "/img/opt.svg",
        title: "Belum ada resep optik",
        content: "Input resep optik dengan mengeklik tombol Ubah Resep Optik",
        size: "small",
        link: "",
        label: "",
      },
      metodeBayar: ["Umum", "BPJS", "Asuransi Lain"],
      resiko: [
        "Rendah",
        "Rendah",
        "Rendah",
        "Rendah",
        "Sedang",
        "Sedang",
        "Sedang",
        "Sedang",
        "Tinggi",
        "Tinggi",
        "Tinggi",
      ],
      tabActive: "pemeriksaan",
      formSet: {
        id_petugas: "",
        id_petugas_lab: "",
        id_dokter: "",
        lab_type: "",
      },
      doc: [],
      nrs: [],
      both: [],
      lab: [],
      obat: [],
      optik: [],
      resepOptik: null,
      slug: "",
    };
  },
  methods: {
    // activateTab(tab) {
    //   this.tabActive = tab.link;
    //   this.tabs = this.tabs.map(item => {
    //     if (item.active) {
    //       item.active = false;
    //     }
    //     if (tab.link == item.link) {
    //       item.active = true;
    //     }
    //     return item;
    //   });
    // },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/${this.$route.params.id}?darurat=0`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          let ralan = result.data;
          if (ralan.asal_rujukan && ralan.asal_rujukan != "null") {
            let faskes = await this.$store.state.HTTP.get(
              `faskes/${ralan.asal_rujukan}`
            );
            if (faskes.status == "200") {
              ralan.asal_rujukan_formatted = faskes.data.nama;
            }
          }

          if (ralan.tujuan_rujukan && ralan.tujuan_rujukan != "null") {
            let faskes_tujuan = await this.$store.state.HTTP.get(
              `faskes/${ralan.tujuan_rujukan}`
            );
            if (faskes_tujuan.status == "200") {
              ralan.tujuan_rujukan_formatted = faskes_tujuan.data.nama;
            }
          }
          //console.log(JSON.stringify(ralan));
          this.status = ralan.status;
          this.$set(this.data, "actionBtn", [
            {
              type: "status",
              className: `badge-${this.classes[this.status]}`,
              label: this.status,
            },
          ]);
          this.id_ralan = ralan.id;
          //console.log(ralan);
          this.detailTop = setPatientIntro(dataPasien);
          //console.log(this.detailTop);
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                },
                {
                  label: "Tanggal/Waktu Periksa",
                  content: ralan.formatted_tgl_jam_periksa,
                  icon: "access_time",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Unit",
                  content: ralan.unit.nama,
                  icon: "label_outline",
                },
                {
                  label: "Jenis Periksa",
                  content: ralan.jen_periksa,
                  icon: "filter_center_focus",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Dokter yang Dituju",
                  content: ralan.dokter.formatted_nama,
                  icon: "person_pin",
                },
                {
                  label: "Status",
                  content: ralan.status,
                  icon: "check_circle",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Tindak Lanjut Penanganan",
                  content: ralan.tindak_lanjut_pelayanan,
                  icon: "ward",
                },
                {
                  label: "Tujuan Rujukan",
                  content: ralan.merujuk
                    ? ralan.tujuan_rujukan_formatted
                    : "Tidak Ada",
                  icon: "home_health",
                },
              ],
            },
          ];

          this.detailRightTop = [
            {
              label: "No. Antrian Dokter",
              content: ralan.no_antrian_dokter,
              icon: "keyboard_capslock",
            },
            {
              label: "Metode Pembayaran",
              content: this.metodeBayar[parseInt(ralan.id_asuransi) - 1],
              icon: "payment",
            },
            {
              label: `Nomor Peserta ${
                this.metodeBayar[parseInt(ralan.id_asuransi) - 1]
              }`,
              content: ralan.no_peserta || "-",
              icon: "contacts",
            },
            {
              label: "Asal Rujukan",
              content: ralan.dirujuk
                ? ralan.asal_rujukan_formatted
                : "Tanpa Rujukan",
              icon: "rotate_right",
            },
          ];
          //console.log(this.detailRightTop);
          if (ralan.rln_periksa_ptg) {
            let dataPetugas = setPeriksaPetugas(
              ralan.rln_periksa_ptg,
              this.$store.state.baseStorageURL
            );
            //console.log(setPeriksaPetugas(ralan.rln_periksa_ptg));
            //console.log(dataPetugas);
            this.dataPetugasLeft = dataPetugas.left;
            this.dataPetugasRight = dataPetugas.right;
          }
          if (ralan.rln_periksa_dok) {
            //console.log(ralan);
            //console.log(ralan.rln_periksa_dok);
            let result = await this.$store.state.HTTP.get(
              `ralan/pemeriksaan/dokter/${ralan.rln_periksa_dok.id}`
            );
            //console.log(result);
            ralan.rln_periksa_dok.rln_periksa_dok_penyakit =
              result.data.rln_periksa_dok_penyakit;
            let dataDokter = setPeriksaDokter(ralan.rln_periksa_dok);
            //console.log(dataDokter);
            this.dataDokterLeft = dataDokter.left;
            this.dataDokterRight = dataDokter.right;
          }
          if (ralan.rln_periksa_oph) {
            //console.log(ralan.rln_periksa_oph);

            this.dataOphthalmic = setPeriksaOphthalmic(
              ralan.rln_periksa_oph,
              this.$store.state.baseStorageURL
            );
            this.dataTabelOphthalmic = ralan.rln_periksa_oph;
          }
          this.fetchTindakan(ralan.no_rawat);
          this.fetchLab(ralan.no_rawat);
          this.fetchObat(ralan.no_rawat);
          this.fetchOptik(ralan.no_rawat);
          this.fetchResepOptik(ralan.no_rawat);
          //console.log('normal');
          //console.log(JSON.stringify(ralan));
          this.slug = this.CryptoJS.AES.encrypt(
            JSON.stringify(ralan),
            this.$store.state.simrsSecretPassphrase
          )
            .toString()
            .replace(/\//g, "fRWdSl45h");
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    fetchObat: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/obat?no_rawat=${no_rawat}&ranap_obat=0`
        );
        //console.log(result);
        let self = this;
        let len = self.obat.length;
        for (var i = 0; i < len; i++) {
          self.obat.pop();
        }
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchOptik: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/barang/optik?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_optik = item.id;
            item.id = item.optik.id;
            item.kode = item.optik.kode;
            item.nama = item.optik.nama;
            item.jenis = item.optik.jenis;
            item.lokasi = item.optik.lokasi;
            self.optik.push(item);
          });
          self.optik = self.optik.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchResepOptik: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/optik?no_rawat=${no_rawat}`
        );
        //console.log(result);
        // let self=this;
        if (result.status == "200") {
          //console.log('resep-optik');
          //console.log(result);
          //console.log('resep-optik');
          if (result.data) {
            this.resepOptik = result.data;
            // //console.log(this.resepOptik);
            this.resepOptik.id_resep = this.resepOptik.id;
          }
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchTindakan: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/tindakan/penanganan?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          let tindDoc = result.data.penanganan_dokter;
          tindDoc.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.doc = self.doc.concat(item);
          });
          self.doc = self.doc.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          let tindBoth = result.data.penanganan_dokter_petugas;
          tindBoth.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.both = self.both.concat(item);
          });
          self.both = self.both.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          let tindNrs = result.data.penanganan_petugas;
          tindNrs.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            // self.nrs.push(item);
            self.nrs = self.nrs.concat(item);
          });
          self.nrs = self.nrs.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          if (tindBoth.length) {
            self.formSet.id_petugas = String(tindBoth[0].id_petugas);
            self.formSet.id_dokter = String(tindBoth[0].id_dokter);
          } else {
            if (tindNrs.length) {
              self.formSet.id_petugas = String(tindNrs[0].id_petugas);
            }
            if (tindDoc.length) {
              self.formSet.id_dokter = String(tindDoc[0].id_dokter);
            }
          }
          //console.log(self);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchLab: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/lab?no_rawat=${no_rawat}`
        );
        console.log(result);
        let self = this;
        if (result.status == "200") {
          self.lab = [];
          result.data.data
            .filter((item) => item.status != "DIBATALKAN")
            .forEach((item) => {
              item.nama = item.periksalab.nama;
              item.kode = item.periksalab.kode;
              item.id_ralan_lab = item.id;
              item.id = item.periksalab.id;
              self.lab = self.lab.concat(item);
            });
          if (result.data.data.length) {
            self.formSet.id_petugas_lab = String(
              result.data.data[0].id_petugas
            );

            self.formSet.lab_type = result.data.data[0].kategori;
          }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    if (this.$route.query.tab) {
      this.tabActive = this.$route.query.tab.toLowerCase();
    }
    this.displayData();
  },
};
</script>
